module.exports = __webpack_public_path__ + "img/title-1.d20964ed.png";